import { useLayoutEffect, useRef, useState } from 'react';

export function useIsOverflowing<T extends HTMLElement>(dependency: unknown) {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    setIsOverflowing(
      element ? element.scrollHeight > element.clientHeight : false,
    );
  }, [dependency]);

  return { ref, isOverflowing };
}
